import {Select as SelectBase, withStyles} from '@yandex-taxi/go-web-components'

// TODO селект остался только в connected-controls (а оттуда юзается только в account/pages/signup, которые хз как тестить), после выпила можно сжечь и заменить на v2
/** @deprecated use `import {Selectv2 as Select} from '@logistics-frontend/blocks/v2` */
export const Select = withStyles(
  theme => ({
    root: {
      [theme.breakpoints.down('sm')]: {
        // костыли для мобилки
        // почему-то на мобилке на инпут приходилось кликать дважды, чтобы зафокусить
        // тут просто лютейший каскад
        '&:hover .MuiAutocomplete-endAdornment .MuiAutocomplete-clearIndicator': {
          visibility: 'hidden',
        },
      },
    },
  }),
  {name: 'LFSelect'},
)(SelectBase)

export {AutocompleteRenderOptionState, FilterOptionsState, SelectProps} from '@yandex-taxi/go-web-components'
